import Permission from './persmission'

const DataPermissions = {
  FIND  : new Permission('FIND'),
  REMOVE: new Permission('REMOVE'),
  UPDATE: new Permission('UPDATE'),
}

export default DataPermissions



// WEBPACK FOOTER //
// ./src/data/permissions/index.js